export default __webpack_public_path__ + "static/sz-logo-81715bceb21885b194c8c340e9b51490.png";